import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/9hBG6bzycJ7d5ZCd9A6qzm/sin_fondo.png';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-[#6BB8D4]/15 pearl-border" data-id="element-119">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-120">
        <div className="flex-shrink-0 w-16" data-id="element-121"></div>

        {/* Center: Parking Info (Hidden on very small screens to avoid crowding) */}
        <div className="hidden md:flex flex-1 justify-center px-4" data-id="element-122">
          <span className="text-[#00E5FF] font-semibold text-sm lg:text-base tracking-wide" style={{
          textShadow: '0 0 10px rgba(0,229,255,0.8), 0 0 20px rgba(0,255,213,0.4)'
        }} data-id="element-123">
            30 min de cochera de cortesía (calle Ricchieri 1138)
          </span>
        </div>

        {/* Right: Controls (Universal for Mobile & Desktop) */}
        <div className="flex items-center gap-3 sm:gap-5" data-id="element-124">
          <a href="https://api.whatsapp.com/send?phone=543417198352&text=Hola!%20Quiero%20reservar%20un%20turno." target="_blank" rel="noopener noreferrer" className="px-4 py-1.5 sm:px-6 sm:py-2 bg-[#00E5FF] text-rotterdam-black text-[10px] sm:text-sm font-bold tracking-wide uppercase rounded-full shadow-[0_0_15px_rgba(0,229,255,0.6)] hover:shadow-[0_0_25px_rgba(0,255,213,0.8)] transition-all duration-300 animate-pulse" data-id="element-125">
            Reserva hoy
          </a>
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-[#00E5FF] p-1 hover:text-white transition-colors" aria-label="Menú" data-id="element-126">
            {isMenuOpen ? <X size={28} data-id="element-127" /> : <Menu size={28} data-id="element-128" />}
          </button>
        </div>
      </div>

      {/* Menu Overlay (Universal) */}
      <AnimatePresence data-id="element-129">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="bg-rotterdam-black border-b border-[#6BB8D4]/15 overflow-hidden shadow-2xl" data-id="element-130">
            <div className="flex flex-col px-6 py-4 gap-2 max-w-6xl mx-auto" data-id="element-131">
              <a href="/#location" onClick={closeMenu} className="text-[#6BB8D4] pearl-text hover:text-white transition-colors text-sm sm:text-base font-bold tracking-wide uppercase py-3 border-b border-gray-800/50" data-id="element-132">
                Ubicación
              </a>
              <a href="/#services" onClick={closeMenu} className="text-[#6BB8D4] pearl-text hover:text-white transition-colors text-sm sm:text-base font-bold tracking-wide uppercase py-3 border-b border-gray-800/50" data-id="element-133">
                Servicios
              </a>
              <a href="/#gift-cards" onClick={closeMenu} className="text-[#6BB8D4] pearl-text hover:text-white transition-colors text-sm sm:text-base font-bold tracking-wide uppercase py-3 border-b border-gray-800/50" data-id="element-134">
                Gift Card
              </a>
              <a href="/#getting-ready" onClick={closeMenu} className="text-[#6BB8D4] pearl-text hover:text-white transition-colors text-sm sm:text-base font-bold tracking-wide uppercase py-3 border-b border-gray-800/50" data-id="element-135">
                Getting Ready
              </a>
              <a href="/#faq" onClick={closeMenu} className="text-[#6BB8D4] pearl-text hover:text-white transition-colors text-sm sm:text-base font-bold tracking-wide uppercase py-3" data-id="element-136">
                Preguntas frecuentes
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}